@if (innovationRequestDetailService.request) {
    <div class="detail-header">
        <div>
            @if(innovationRequestDetailService.request.personQuery.belenderCircuit === 6) {
                <div class="flex">
                    <button pButton class="P8" styleClass="p-button-rounded p-button-danger p-button-text" [rounded]="true" [text]="true" (click)="navigateToRequests()">
                        <span class="material-symbols-outlined"> arrow_back </span>
                    </button>
                    <h3 tooltipPosition="top" [pTooltip]="'MY_REQUESTS.LEGAL_NAME' | translate">
                        {{ innovationRequestDetailService.request.personQuery.companyName }}
                    </h3>
                    <span class="mini-separator"></span>
                    <span class="bold600 font14" tooltipPosition="top" [pTooltip]="'MY_REQUESTS.TIN' | translate">
                        {{ innovationRequestDetailService.request.personQuery.companyId }}
                    </span>
                    <p class="font11" tooltipPosition="top" [pTooltip]="'MY_REQUESTS.IDENTIFIER' | translate">
                        {{ innovationRequestDetailService.request.personQuery.queryId }}
                    </p>
                </div>
                <div class="flex PL50">
                    <p tooltipPosition="top" [pTooltip]="'MY_REQUESTS.TYPE' | translate">
                        <span class="material-symbols-outlined"> contract </span>
                        {{ queryTypeTitle }}
                    </p>
                    <p tooltipPosition="top" [pTooltip]="'REQUEST_DETAIL.LEGAL_REPRESENTATIVE' | translate">
                        <span class="material-symbols-outlined"> person </span>
                        {{ innovationRequestDetailService.getRequestFullPersonName() }}
                    </p>
                    <p tooltipPosition="top" [pTooltip]="'REQUEST_DETAIL.LEGAL_REPRESENTATIVE' | translate">
                        <span class="material-symbols-outlined"> id_card </span>
                        {{ innovationRequestDetailService.request.personQuery.personId }}
                    </p>
                    <p tooltipPosition="top" [pTooltip]="'MY_REQUESTS.PHONE' | translate">
                        <span class="material-symbols-outlined"> phone </span>
                        {{ innovationRequestDetailService.request.personQuery.phoneNumber }}
                    </p>
                    <p tooltipPosition="top" [pTooltip]="'REQUEST_DETAIL.EMAIL' | translate">
                        <span class="material-symbols-outlined"> mail </span>
                        {{ innovationRequestDetailService.request.personQuery.email }}
                    </p>
                </div>
            } @else {
                <div class="flex">
                    <button pButton class="P8" styleClass="p-button-rounded p-button-danger p-button-text" [rounded]="true" [text]="true" (click)="navigateToRequests()">
                        <span class="material-symbols-outlined"> arrow_back </span>
                    </button>
                    <h3 tooltipPosition="top" [pTooltip]="'MY_REQUESTS.NAME' | translate">
                        {{ innovationRequestDetailService.getRequestFullPersonName() }}
                    </h3>
                    <span class="mini-separator"></span>
                    <span class="bold600 font14" [pTooltip]="'MY_REQUESTS.IDENTIFIER' | translate" tooltipPosition="top">
                        {{ innovationRequestDetailService.request.personQuery.queryId }}
                    </span>
                </div>
                <div class="flex PL50">
                    <p [pTooltip]="'MY_REQUESTS.TIN' | translate" tooltipPosition="top">
                        <span class="material-symbols-outlined"> id_card </span>
                        {{ innovationRequestDetailService.request.personQuery.personId }}
                    </p>
                    <p [pTooltip]="'MY_REQUESTS.TYPE' | translate" tooltipPosition="top">
                        <span class="material-symbols-outlined"> contract </span>
                        {{ queryTypeTitle }}
                    </p>
                    <p pTooltip="{{ 'MY_REQUESTS.PHONE' | translate }}" tooltipPosition="top">
                        <span class="material-symbols-outlined"> phone </span>
                        {{ innovationRequestDetailService.request.personQuery.phoneNumber }}
                    </p>
                </div>
            }
        </div>

        <div class="flex">
            <div class="flex-column">
                <p class="font11 MB0 center">{{ 'REQUEST_DETAIL.REQUEST_DATE' | translate }}</p>
                <p class="date-box">{{ innovationRequestDetailService.request.personQuery.createdDateTime | date: 'dd/MM/yyyy HH:mm' }}</p>
            </div>

            @if (innovationRequestDetailService.request.personQuery.isDocumentsDowloadCompleted) {
                <div class="flex-column">
                    <p class="font11 MB0 center">{{ 'REQUEST_DETAIL.DOWNLOAD_DOCUMENTS' | translate }}</p>
                    <p class="date-box document-check">
                        <span class="material-symbols-outlined"> done_all </span>
                    </p>
                </div>
            }
        </div>
        <div class="flex-column align-center">
            <p tooltipPosition="left" [pTooltip]="'REQUEST_DETAIL.STATUS' | translate" [class]="'actual-status ' + innovationRequestDetailService.request.personQuery.status">
              {{ translatedStatus }}
            </p>
            <p class="actual-sub-status" tooltipPosition="left" [pTooltip]="'REQUEST_DETAIL.SUBSTATUS' | translate">
              {{ translatedSubStatus }}
            </p>
        </div>
    </div>
}
